<app-calendly-green-mobility-dialog></app-calendly-green-mobility-dialog>
<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="selectedSidebarItemId" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.services' | transloco }}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="selectedSidebarItemId"></app-mobile-topbar>
            <div class="flex flex-wrap gap-6 items-center mobile:justify-evenly">
                <app-tab-button label="{{ 'services.pv_roof' | transloco }}" link="/services/pv-roof"></app-tab-button>
                <app-tab-button label="{{ 'shared.esg_reporting' | transloco }}"
                    link="/services/esg-reportings"></app-tab-button>
                <app-tab-button label="{{ 'shared.green_mobility' | transloco }}" [isActive]="true"
                    link="/services/green-mobility"></app-tab-button>
            </div>

            <div class="flex flex-col w-full gap-5 justify-center text-center mt-10 mobile:mt-4 max-w-ultrawide">
                <p class="text-5xl mobile:text-xl font-bold text-black">{{ 'services.sustainable_mobility_solutions' |
                    transloco }}</p>
                <p class="text-xl mobile:text-base text-neutral-700">{{
                    'services.sustainable_mobility_solutions_description' | transloco }}</p>

                <div class="flex flex-wrap w-full justify-center mobile:flex-col mobile:items-center gap-5 mt-10">

                    <app-green-mobility-card imageSrc="assets/images/green-mobility/charging-columns.png"
                        iconSrc="assets/icons/battery-primary.svg" title="{{
                'services.charging_columns_title' | transloco }}" description="{{
                    'services.charging_columns_description' | transloco }}"
                        buttonText="{{ 'optimization.talk_to_specialist' | transloco }}"
                        (buttonClick)="talkToSpecialist()"></app-green-mobility-card>

                    <app-green-mobility-card imageSrc="assets/images/green-mobility/wallboxes.png"
                        iconSrc="assets/icons/power-primary.svg" title="{{
                'services.wallboxes_title' | transloco }}" description="{{
                    'services.wallboxes_description' | transloco }}"
                        buttonText="{{ 'optimization.talk_to_specialist' | transloco }}"
                        (buttonClick)="talkToSpecialist()"></app-green-mobility-card>

                    <app-green-mobility-card imageSrc="assets/images/green-mobility/bikes.png"
                        iconSrc="assets/icons/bike-primary.svg" title="{{
                'services.ebikes_escooters_title' | transloco }}" description="{{
                    'services.ebikes_escooters_description' | transloco }}"
                        buttonText="{{ 'optimization.talk_to_specialist' | transloco }}"
                        (buttonClick)="talkToSpecialist()"></app-green-mobility-card>
                </div>
            </div>
        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>